import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  mainContainer: {
    flexGrow: 1,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(3),
  },
  particles: {
    zIndex: -1,
    position: 'fixed',
    width: '100%',
    height: '100%'
  }
}))

export default useStyles